var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{on:{"click":function($event){$event.stopPropagation();return _vm.goToBilling()}}},[_vm._t("default",[_vm._v("Upgrade")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }